import React from 'react';

import type {
  MarketId,
  MarketLevelCompoundMarketTemplateColumnClientConfig
} from '@swf/generated/types/api/sports';

import TableColumnTable from '../../components/TableColumnTable/TableColumnTable';

interface Props extends MarketLevelCompoundMarketTemplateColumnClientConfig {
  marketIds: (MarketId | null)[];
}

const TableColumn: React.FC<Props> = (props) => <TableColumnTable {...props} />;

export default TableColumn;
